/**
 * Normalize family occupancy from AI trip plans and hotel search forms.
 * A trip plan may encode children as 2, "2", or [{birthDate}].
 * Ages are computed on check-in day and NEVER guessed.
 */
function parseDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const parts = value.split('-').map(Number);
  const d = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
  if (d.getUTCFullYear() !== parts[0] || d.getUTCMonth() + 1 !== parts[1] || d.getUTCDate() !== parts[2]) return null;
  return parts;
}

export function childCount(children) {
  if (Array.isArray(children)) return children.length;
  const n = Number(children);
  return Number.isFinite(n) ? Math.max(0, Math.min(12, Math.trunc(n))) : 0;
}

export function ageAtCheckIn(birthDate, checkIn) {
  const birth = parseDate(birthDate);
  const arrival = parseDate(checkIn);
  if (!birth || !arrival) return null;
  let age = arrival[0] - birth[0];
  if (arrival[1] < birth[1] || (arrival[1] === birth[1] && arrival[2] < birth[2])) age -= 1;
  if (age < 0 || age > 17) return null;
  return age;
}

export function bookingChildren(children, checkIn, birthDates = []) {
  const count = childCount(children);
  const candidates = Array.isArray(children) && children.length
    ? children.map(child => typeof child === 'string' ? child : child?.birthDate)
    : birthDates;
  if (!count || !Array.isArray(candidates) || candidates.length !== count) {
    return { count, ages: [] };
  }
  const ages = candidates.map(birthDate => ageAtCheckIn(birthDate, checkIn));
  return { count, ages: ages.every(Number.isInteger) ? ages : [] };
}
